import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch } from "react-redux";
import { setForum } from "../../../core/redux/forumSlice";
import { convertTimestampToDate } from "../../../core/common/ults/dateTime";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { useMemo } from "react";
import { useHandleForum } from "../../../core/hooks/useHandleForum";
import { useTranslation } from "react-i18next";

const ForumCard = ({ forumData }: any) => {
  const route = all_routes;
  const dispatch = useDispatch();
  const { moodleUser } = useAuth();
  const { enrolledCourses } = useHandleCourses(moodleUser?.id);
  const { t } = useTranslation();
  const { viewForum } = useHandleForum();

  // Tối ưu: Tính tên khoá học 1 lần khi cần
  const courseName = useMemo(() => {
    const courses = Array.isArray(enrolledCourses) ? enrolledCourses : [];
    if (!courses.length || !forumData?.course) return t("student.forums.card.unknownCourse");
    const course = courses.find((course: any) => course.id === forumData.course);
    return course?.fullname || t("student.forums.card.unknownCourse");
  }, [enrolledCourses, forumData?.course, t]);

  // Tối ưu: Tính thời gian 1 lần
  const modifiedTime = useMemo(() => {
    return convertTimestampToDate(forumData?.timemodified);
  }, [forumData?.timemodified]);

  return (
    <>
      <div className="forum-card-container position-relative mb-4 forum-card-hover" style={{ 
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
        padding: '20px',
        borderRadius: '20px',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
      }}>
        <Link
          to={`${route.studentForumDetails}/${forumData.id}`}
          className="forum-card-link text-decoration-none text-dark d-block"
          onClick={() => {
            dispatch(setForum(forumData));
            try { viewForum(forumData.id); } catch {}
          }}
        >
          <div className="forum-card bg-white position-relative overflow-hidden" style={{
            borderRadius: '16px',
            padding: '20px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            transition: 'all 0.3s ease'
          }}>
            <div className="d-flex align-items-start forum-card-content" style={{ gap: '20px' }}>
              {/* Forum Image */}
              <div className="d-flex align-items-center justify-content-center flex-shrink-0 forum-card-image" style={{
                width: '80px',
                height: '80px',
                background: '#f8f9fa',
                borderRadius: '12px',
                border: '2px solid #e9ecef'
              }}>
                <i className="isax isax-message-text-1 text-muted" style={{ fontSize: '32px' }} />
              </div>

              {/* Content */}
              <div className="flex-fill" style={{ minWidth: 0 }}>
                <h5 className="mb-2 fw-semibold" style={{ 
                  fontSize: '18px', 
                  color: '#2c3e50',
                  lineHeight: '1.3'
                }}>
                  {forumData?.name}
                </h5>

                {/* Course info */}
                <div className="mb-3">
                  <div className="d-flex align-items-center mb-1 text-muted" style={{ fontSize: '14px' }}>
                    <i className="isax isax-teacher5 me-2" style={{ fontSize: '16px' }} />
                    <span className="fw-medium">{t("student.forums.card.course")}:</span>
                    <span className="ms-1">{courseName}</span>
                  </div>
                </div>

                {/* Last modified info */}
                <div>
                  <div className="d-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                    <i className="isax isax-clock me-2" style={{ fontSize: '16px' }} />
                    <span className="fw-medium">{t("student.forums.card.lastModified")}:</span>
                    <span className="ms-1">{modifiedTime}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default ForumCard;
